/* cspell:disable -- Cognito client IDs are opaque strings */
export const COGNITO_IDS: Record<string, { userPoolId: string; clientId: string }> = {
  staging: { userPoolId: "us-west-2_HV1ibP3I6", clientId: "6v67adqpeaf6bsh0v8o26lrdjm" },
  "prod-shadow": { userPoolId: "us-west-2_1tSFVnCSa", clientId: "37ibpdk8sp79hmber3e20frcgn" },
  production: { userPoolId: "us-west-2_in7ey5PCw", clientId: "7ciadki7t9r81uc82ag7cfg995" },
  development: { userPoolId: "us-west-2_N0koNIUOZ", clientId: "1tv8sqhok9v1inht70cj77fcgd" },
};
